// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__31Q7I","footer":"ModalFilter_footer__2B_2f"};